<template>
  <div class="fluid page_content catalog_list">
    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ico-catalog"></span>
        <span class="module_type_name">Course Catalog Management</span>
      </div>
      <div class="col-5 btn_container">
        <b-btn @click="upload" aria-label="upload">upload</b-btn>
        <b-btn @click="showDeleteConfirm" aria-label="delete all" :disabled="(catalogs.length === 0)">delete all</b-btn>
      </div>
    </div>

    <div class="course-management-section">
      <div class="page_subheading">
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1 }}</span>
            <button type="button" :disabled="lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" v-model="keyword" placeholder="filter by course catalog title" aria-label="filter by course" v-on:keyup.enter="searchCatalogs">
            <button type="button" class="btn btn_srh" @click="searchCatalogs" aria-label="search catalogs">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="course-management-table-container">
        <table class="table b-table table-bordered border">
          <thead class="thead-light text-center">
            <tr>
              <th class="first-column">Course Catalog Title</th>
              <th class="second-column">Owner</th>
              <th class="third-column">Date Updated</th>
              <th class="fourth-column"></th>
            </tr>
          </thead>
          <tbody v-if="catalogs.length > 0">
            <tr v-for="catalog in catalogs">
              <td class="first-column">
                <span>{{catalog.title}}</span><br/>
              </td>
              <td class="second-column text-center">
                <span>{{catalog.ownerName}}</span><br/>
              </td>
              <td class="third-column">
                <span>{{getFormattedDateTime(catalog.lastUpdatedTime)}}</span>
              </td>
              <td class="fourth-column">
                <b-btn @click="viewCatalog(catalog)" aria-label="view catalog">view</b-btn>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="no-result" style="text-align: center;">No Catalogs Found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <b-modal id="modal-delete-all-popup" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered :header-bg-variant="'popup-header'">
        <div style="text-align: center;">
           <h6>Are you sure you want delete all ({{totalElements}}) Course Catalogs?</h6>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="$refs.deleteConfirmModal.hide()">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteAll" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="$refs.deleteConfirmModal.hide()" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import '../../../assets/module/css/course/courseList.min.css'

  export default {
    name: 'catalog-list',
    data () {
      return {
        catalogs: [],
        pageSize: 10,
        sizeOptions: [ 10, 50, 100 ],
        firstPage: true,
        lastPage: false,
        page: 0,
        totalElements: 0,
        keyword: ''
      }
    },
    mounted () {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.loadCatalogList()
      }, 500)
    },
    methods: {
      ...mapActions([
        'loadCatalogs',
        'loadDeleteAllCatalogs'
      ]),
      loadCatalogList (keyword) {
        this.loadCatalogs({page: this.page, count: this.pageSize, keyword: keyword}).then(result => {
          this.catalogs = result.content
          this.firstPage = result.first
          this.lastPage = result.last
          this.page = result.number
          this.totalElements = result.totalElements
          this.$refs.loadingModal.hide()
        })
      },
      upload () {
        return this.$router.push({name: 'catalogUpload'})
      },
      showDeleteConfirm () {
        this.$refs.deleteConfirmModal.show()
      },
      async deleteAll () {
        this.$refs.deleteConfirmModal.hide()
        let resp = await this.loadDeleteAllCatalogs()
        return this.$router.push({name: 'taskMonitor', params: {taskId: resp.taskId}})
      },
      getFormattedDateTime (ms) {
        return DateTime.fromMillis(ms).toFormat('LLL dd, yyyy t')
      },
      viewCatalog (catalog) {
        return this.$router.push({name: 'catalogDetail', params: {uuid: catalog.uuid}})
      },
      keyupEvent (event) {
        this.page = 0
        this.loadCatalogList(this.keyword)
      },
      searchCatalogs () {
        this.page = 0
        this.loadCatalogList(this.keyword)
      },
      resetPage () {
        this.page = 0
        this.loadCatalogList(this.keyword)
      },
      prev () {
        this.page -= 1
        if (this.keyword.length > 0) {
          this.loadCatalogList(this.keyword)
        } else {
          this.loadCatalogList()
        }
      },
      next () {
        this.page += 1
        if (this.keyword.length > 0) {
          this.loadCatalogList(this.keyword)
        } else {
          this.loadCatalogList()
        }
      }
    }
  }
</script>

<style>
  .popup_head_txt {
    font-size: 1.1rem;
    float: left;
    color: #323232;
  }

  .bg-popup-header {
    background: #c0c0c0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/catalog/components/CatalogList.vue